module.exports = __webpack_public_path__ + "static/media/thumbs-down.0467628f.svg";